<template>
    <div>
        <div v-if="loading">
            <div class="spinner"></div>
        </div>

        <div v-else-if="errors.length" class="alert--error" >
            <p v-for="err in errors" :key="err"> {{ err }} </p>
        </div>

        <form v-if="!loading" class="form" @submit.prevent="save">
            <slot name="header"></slot>

            <div :class="wrapperClass">
                <div class="form__item">
                    <input v-model="date" class="form__input--text has-value" type="datetime-local" required />
                    <label class="form__label">{{$t('forms.note.date')}}</label>
                </div>

                <div class="form__item">
                    <textarea v-model="note.note" class="form__input--text" required :class="{ 'has-value': note.note }"/>
                    <label class="form__label">{{$t('forms.note.note')}}</label>
                </div>

                <div class="form__item">
                    <label class="form__top_label">{{$t('forms.note.visibility')}}</label>
                    <div class="checkbox">
                        <input type="checkbox" class="checkbox__cb" id="trajectory_form__visible_client" v-model="note.visible_client" @change="preventVisibleClientChange"/>
                        <label for="trajectory_form__visible_client" class="checkbox__label"> {{$t('forms.note.visible_client')}}</label>
                    </div>
                    <confirmation-alert
                        :show="showVisibleClientAlert"
                        message="forms.note.alert_visible_client"
                        @confirm="confirmVisibleClient"
                        @reject="declineVisibleClient"/>

                    <div class="checkbox">
                        <input type="checkbox" class="checkbox__cb" id="trajectory_form__visible_employer" v-model="note.visible_employer" @change="preventVisibleEmployerChange" />
                        <label for="trajectory_form__visible_employer" class="checkbox__label"> {{$t('forms.note.visible_employer')}}{{contactName ? ': ' + contactName : ''}}</label>
                    </div>
                    <confirmation-alert
                        :show="showVisibleEmployerAlert"
                        message="forms.note.alert_visible_employer"
                        @confirm="confirmVisibleEmployer"
                        @reject="declineVisibleEmployer"/>
                </div>
            </div>

            <slot name="buttons" :isSaveDisabled="isSaveDisabled">
                <div class="form__buttons">
                    <button type="submit" class="form__button button--cta" :class="{disabled: isSaveDisabled}" :disabled="isSaveDisabled">{{$t('common.save')}}</button>
                </div>
            </slot>
        </form>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop, Watch} from 'vue-property-decorator';
    import Note from '@/models/Note';
    import ConfirmationAlert from '@/components/general/ConfirmationAlert';


    @Component({
        components: {
            ConfirmationAlert,
        }
    })
    export default class NoteForm extends Vue {

        @Prop({ type: Array | String, default() {
            return [];
        } })
        wrapperClass;

        @Prop({ type: Note, default() {
            return new Note();
        }})
        note;

        created() {
            this.errors = [];
        }

        get isSaveDisabled() {
            return !this.note.note;
        }

        saveLoading = false;

        get loading () {
            return this.saveLoading;
        }

        get date() {
            if (this.note.date) {
                // Convert to ISO format without second as required by the input;
                return this.note.date.split(' ')[0] + 'T' + (this.note.date.split(' ')[1].split(':').slice(0, -1).join(':'));
            } else {
                // Convert current datetime to the format required by the input.
                var tzoffset = (new Date()).getTimezoneOffset() * 60000;
                var localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);
                return localISOTime.split(':').slice(0, -1).join(':');
            }
        }

        set date(date) {
            if (date) {
                // Change the datetime format to the one required by the backend: YYYY-MM-DD HH:MM:SS;
                this.note.date = date.split('T')[0] + ' ' + date.split('T')[1] + ':00';
            }
        }

        get contactName() {
            return this.$store.state.trajectory.trajectory.contact_name;
        }

        showVisibleClientAlert = false;
        showVisibleEmployerAlert = false;

        preventVisibleClientChange(event) {
            if (this.note.visible_client) {
                this.$set(this.note, 'visible_client', false);
                this.showVisibleClientAlert = true;
            }
        }

        preventVisibleEmployerChange() {
            if (this.note.visible_employer) {
                this.$set(this.note, 'visible_employer', false);
                this.showVisibleEmployerAlert = true;
            }
        }

        confirmVisibleClient() {
            this.$set(this.note, 'visible_client', true);
            this.showVisibleClientAlert = false;
        }

        declineVisibleClient() {
            this.$set(this.note, 'visible_client', false);
            this.showVisibleClientAlert = false;
        }

        confirmVisibleEmployer() {
            this.$set(this.note, 'visible_employer', true);
            this.showVisibleEmployerAlert = false;
        }

        declineVisibleEmployer() {
            this.$set(this.note, 'visible_employer', false);
            this.showVisibleEmployerAlert = false;
        }

        save() {
            this.errors = [];
            this.saveLoading = true;
            this.note.save()
                .then(res => this.$emit('saved', res))
                .catch(
                    err => {
                        if (err.status === 422) {
                            this.errors = err.errors;
                        } else {
                            this.errors = [this.$t('common.unknown_error')];
                        }
                    })
                .then(() => this.saveLoading = false);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/forms/dashboard/NoteForm.vue